import { render, staticRenderFns } from "./UpdateIcon.vue?vue&type=template&id=622ee91c&"
import script from "./UpdateIcon.vue?vue&type=script&lang=js&"
export * from "./UpdateIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports